import { GOOGLE_MAP_EMBED_API_KEY } from "@/environments/googleMapEmbedKey"

type GoogleMapVariant =
    | {
          type: "place"
          query: string
      }
    | {
          type: "directions"
          origin: string
          destination: string
      }

const buildQuery = (variant: GoogleMapVariant): URLSearchParams => {
    const query = new URLSearchParams()
    switch (variant.type) {
        case "place":
            query.set("q", variant.query)
            return query
        case "directions":
            query.set("origin", variant.origin)
            query.set("destination", variant.destination)
            return query
    }
}
const buildSourceURL = (variant: GoogleMapVariant) => {
    const BASE_URI = "https://www.google.com/maps/embed/v1"
    const API_KEY = `key=${GOOGLE_MAP_EMBED_API_KEY}`

    return `${BASE_URI}/${variant.type}?${API_KEY}&${buildQuery(variant).toString()}`
}

export const EmbeddedGoogleMap = ({
    variant
}: {
    variant: GoogleMapVariant
}) => {
    const srcURL = buildSourceURL(variant)

    return (
        <iframe
            title="Google Map Embed"
            width="100%"
            height="296px"
            src={srcURL}
            allowFullScreen
        />
    )
}
